import { Card, Grid, Typography } from '@mui/material'
import styles from '../Information.module.scss'
import Information from '../Information'
import GridTableComponent from '../../common/GridTableComponent/gridTableTemplate'

const PoojaItems = () => {
    const ItemAddedData = [
        {
            ItemsNames: "Rice",
            Quantity: "5 Lb",
        },
        {
            ItemsNames: "Akshata(Yellow Rice)",
            Quantity: "1/2 Lb",
        },
        {
            ItemsNames: "Haldi",
            Quantity: "25 grams",
        },
        {
            ItemsNames: "kumkum",
            Quantity: "25 grams",
        },
        {
            ItemsNames: "camphor",
            Quantity: "1 packet",
        }
    ]
    return (
        <>
            <div >
                <Information />
                <div className={styles.PoojaItemsContainer}>
                    <Card className={styles.cardContainer}>
                        <Grid>
                            <Typography className={styles.content}>
                                The objective of the Samskaras, are several. The removal of evil spirits, invoking blessings from Gods for material gains, longevity and good progeny, are a few of these. Different Mantras are chanted and different gods are worshipped depending upon the ceremony.
                            </Typography>
                        </Grid>
                        <Grid container spacing={2}>
                            <Grid xs={12} sm={3} item>
                                <Typography className={styles.Header}>
                                    Vivaham
                                </Typography>
                                <Grid>
                                    <Typography className={styles.secondcontent}>
                                        All the traditions and Sampradayas agreed that marriage is a divine samskara to get along Dharma, Artha, Kama and Moksha. The Temple helps in conducting marriages. For the Muhurtha (auspicious time), one can get the help of the priest.
                                        You are required to bring these items for conducting a marriage. In fact, you can request the Temple to conduct the wedding in the Temple Assembly Hall or out side.
                                    </Typography>
                                </Grid>
                            </Grid>
                        </Grid>
                        <div style={{ marginTop: "10px" }}>
                            <Grid xs={12} sm={3}>
                                <div className={styles.tableContainer}>
                                    <div className={styles.tableWrapper}>
                                        <GridTableComponent tableData={ItemAddedData} />
                                    </div>
                                    <div className={styles.tableWrapper}>
                                        <GridTableComponent tableData={ItemAddedData} />
                                    </div>
                                    <div className={styles.tableWrapper}>
                                        <GridTableComponent tableData={ItemAddedData} />
                                    </div>
                                </div>
                                <div className={styles.tableContainer}>
                                    <Typography className={styles.secondcontent} >
                                        Two flower garlands will be supplied on request and payment. Advance request is required. You can ask the priest for any special items you may need<br /> to conduct the wedding as per your sampradaya. Please confirm this list with the priest.
                                    </Typography>
                                </div>
                            </Grid>
                        </div>
                        <Grid container spacing={2}>
                            <Grid xs={12} sm={3} item>
                                <Typography className={styles.Header}>
                                    Seemantham
                                </Typography>
                                <Grid>
                                    <Typography className={styles.secondcontent}>
                                        Performed in the 7th or 8th month of pregnancy. You can consult the priest for the auspicious time and the items needed. Veda parayana, Santhi pata pravachana also can be arranged at home or in the Temple. Please contact manager if you need more information.
                                    </Typography>
                                </Grid>
                                <Grid>
                                    <Typography className={styles.secondcontent}>
                                        All the other birth related Samskaras like, Pumsavana (Performed in the 2nd, 3rd, 4th month), Jaatakarma (immediately after child birth), Nama Karana (child naming cermony 10th or 12th day after birth), Punyaha Vachana, Anna prasana (First feeding of cooked rice to child, at 6th month), Mundana, Akshara-abhyasa make the child eligible for the next samskara and purify the body to recive the spiritual vibrations very quickly.
                                    </Typography>
                                </Grid>
                            </Grid>

                        </Grid>
                        <div>
                            <div className={styles.tableContainer}>
                                <div className={styles.tableWrapper}>
                                    <GridTableComponent tableData={ItemAddedData} />
                                </div>
                                <div className={styles.tableWrapper}>
                                    <GridTableComponent tableData={ItemAddedData} />
                                </div>
                            </div>
                            <div className={styles.tableContainer}>
                                <Grid >
                                    <Typography className={styles.secondcontent}>
                                        Extra milk for Annaprasana. One white hand-kerchief and new scissors, extra for Mundan. One slate<br /> for writing material, extra for Akshar-abhayasa.
                                    </Typography>
                                </Grid>
                            </div>
                        </div>
                        <Grid container spacing={2} sx={{ marginTop: "25px" }}>
                            <Grid item xs={12}>
                                <Typography className={styles.upanyayaHeader}>Upanayana (Thread Ceremony)</Typography>
                            </Grid>
                            <Grid item xs={12}>
                                <Typography className={styles.secondcontent}>
                                    A sacred thread is prescribed for the three classes like Brahmana, Kshatriya and Vaisya in their respective traditions and they are advised to consult the priest for their sampradaya. In order to get the eligibility to the Nitya Karma, Veda adhyana and Yajna - Yaga sacrifices, one needs to get the samskara. To set the auspicious Muhurtha you can get help from any priest.
                                </Typography>
                            </Grid>
                        </Grid>
                        <Grid xs={12} sm={3}>
                            <div className={styles.tableContainer}>
                                <div className={styles.tableWrapper}>
                                    <GridTableComponent tableData={ItemAddedData} />
                                </div>
                                <div className={styles.tableWrapper}>
                                    <GridTableComponent tableData={ItemAddedData} />
                                </div>
                                <div className={styles.tableWrapper}>
                                    <GridTableComponent tableData={ItemAddedData} />
                                </div>

                            </div>
                        </Grid>
                        <div className={styles.tableContainer}>
                            <Typography className={styles.secondcontent}>
                                You can ask priest for any special items you wish to include in the Upanayana as per your Sampradaya.
                            </Typography>
                        </div>
                    </Card>
                </div>
            </div>
        </>
    )
}
export default PoojaItems;